/* Returns an object that only contains keys from an object to match against */
export default function objRemoveUnmatchedKeys(objValues, objMatch) {
  const keys = Object.keys(objMatch);
  const objFinal = {};

  keys.forEach((key) => {
    if (objValues[key]) {
      objFinal[key] = objValues[key];
    }
  });

  return objFinal;
}
